var _rect, _mask, _rect2, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeDevelop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    rx: 48,
    fill: "#2E61A1",
    fillOpacity: 0.05
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 60,
    height: 40,
    rx: 1
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 60,
    height: 40,
    rx: 1,
    stroke: "#2E61A1",
    strokeWidth: 8,
    mask: "url(#path-2-inside-1)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 54H78",
    stroke: "#2E61A1",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61 72L57 62H39L35 72H61ZM61 72H68H28",
    stroke: "#2E61A1",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 31C25.8954 31 25 31.8954 25 33C25 34.1046 25.8954 35 27 35H47C48.1046 35 49 34.1046 49 33C49 31.8954 48.1046 31 47 31H27ZM27 37C25.8954 37 25 37.8954 25 39C25 40.1046 25.8954 41 27 41H55C56.1046 41 57 40.1046 57 39C57 37.8954 56.1046 37 55 37H27ZM25 45C25 43.8954 25.8954 43 27 43H39C40.1046 43 41 43.8954 41 45C41 46.1046 40.1046 47 39 47H27C25.8954 47 25 46.1046 25 45ZM45 43C43.8954 43 43 43.8954 43 45C43 46.1046 43.8954 47 45 47H51C52.1046 47 53 46.1046 53 45C53 43.8954 52.1046 43 51 43H45Z",
    fill: "#2E61A1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeDevelop);
export default __webpack_public_path__ + "static/media/we_develop.06c316e58b77de10626eb43abab6774f.svg";
export { ForwardRef as ReactComponent };